import { render, staticRenderFns } from "./WorkingHoursCard.vue?vue&type=template&id=95dd6fcc&scoped=true"
import script from "./WorkingHoursCard.vue?vue&type=script&lang=js"
export * from "./WorkingHoursCard.vue?vue&type=script&lang=js"
import style0 from "./WorkingHoursCard.vue?vue&type=style&index=0&id=95dd6fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dd6fcc",
  null
  
)

export default component.exports